import api from './axiosInstance';

// Types

export interface Client {
  _id: string;
  clientName: string;
  project: Array<string | { _id: string; projectName: string; projectNumber: string }>; // populated or plain
  createdAt: string;
  updatedAt: string;
  additionalInformation: {
    leadPersonName: string;
    phone: string;
    email: string;
    secondaryContact?: string;
    websiteUrl?: string;
    currentPortalCost?: number | '';
    totalUserLimit?: number | '';
    liveUsersLimit?: number | '';
    portalLink?: string;
  };
}


export interface CreateClientData {
  clientName: string;
  additionalInformation: {
    leadPersonName: string;
    phone: string;
    email: string;
    secondaryContact?: string;
    websiteUrl?: string;
  };
  project?: string[];
}


export interface UpdateClientData {
  clientName: string;
  additionalInformation: {
    leadPersonName: string;
    phone: string;
    email: string;
    secondaryContact?: string;
    websiteUrl?: string;
  };
  project?: string[];
}

// API Functions
export const clientApi = {
  // GET /api/clients - Get all clients
  getAllClients: async (): Promise<Client[]> => {
    const response = await api.get('/clients');
    return response.data;
  },

  // GET /api/clients/:id - Get client by ID
  getClientById: async (id: string): Promise<Client> => {
    const response = await api.get(`/clients/${id}`);
    return response.data;
  },

  // POST /api/clients - Create new client
  createClient: async (data: CreateClientData): Promise<Client> => {
    const response = await api.post('/clients', data);
    return response.data;
  },

  // PUT /api/clients/:id - Update client
  updateClient: async (id: string, data: UpdateClientData): Promise<Client> => {
    const response = await api.put(`/clients/${id}`, data);
    return response.data;
  },

  // DELETE /api/clients/:id - Delete client
  deleteClient: async (id: string): Promise<{ message: string }> => {
    const response = await api.delete(`/clients/${id}`);
    return response.data;
  },

  // POST /api/clients/:clientId/tasks/:taskId - Add task to client
  addTaskToClient: async (clientId: string, taskId: string): Promise<Client> => {
    const response = await api.post(`/clients/${clientId}/tasks/${taskId}`);
    return response.data;
  },

  // DELETE /api/clients/:clientId/tasks/:taskId - Remove task from client
  removeTaskFromClient: async (clientId: string, taskId: string): Promise<Client> => {
    const response = await api.delete(`/clients/${clientId}/tasks/${taskId}`);
    return response.data;
  },
};
